import PageHome from './Home';
import PageTools from './Tools';
import PageBanner from './Banner';
import PageRecover from './Recover';
import PageTicket from './Ticket';
import PageExports from './Exports';
import PageValidity from './Validity';
export interface PageProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

export default Object.assign(
  ({ children, className = '', ...rest }: PageProps) => {
    return (
      <div className={`page ${className}`} {...rest}>
        {children}
      </div>
    );
  },
  {
    Home: PageHome,
    Tools: PageTools,
    Banner: PageBanner,
    Ticket: PageTicket,
    Recover: PageRecover,
    Exports: PageExports,
    Validity: PageValidity,
  },
);
